"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var RequestHeadersInterceptor = /** @class */ (function () {
    function RequestHeadersInterceptor() {
    }
    RequestHeadersInterceptor.prototype.intercept = function (req, next) {
        if (!req.headers.has('Content-Type')) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
        }
        return next.handle(req);
    };
    return RequestHeadersInterceptor;
}());
exports.RequestHeadersInterceptor = RequestHeadersInterceptor;
exports.RequestHeadersProvider = { provide: http_1.HTTP_INTERCEPTORS, useClass: RequestHeadersInterceptor, multi: true };
